export default function SafetySection() {
  return (
    <section id="seguranca" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="w-full lg:w-2/5">
            <div className="rounded-2xl overflow-hidden aspect-[4/5]">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20security%20concept%20with%20modern%20lock%20icon%20on%20dark%20navy%20gradient%20background%2C%20soft%20protective%20glow%20effect%2C%20clean%20tech%20aesthetic%2C%20trust%20and%20protection%20symbolism%2C%20minimal%20editorial%20style%2C%20corporate%20security%20photography&width=800&height=1000&seq=safety-v2-hoobuy&orientation=portrait"
                alt="Hoobuy Spreadsheet - Segurança e Confiabilidade"
                title="A Hoobuy Spreadsheet é segura?"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <div className="w-full lg:w-3/5">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide uppercase mb-4">
              Segurança
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight mb-4">
              A Hoobuy<br />
              É Segura?
            </h2>
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-8">
              Nossa equipe verifica cuidadosamente cada link, vendedor e produto antes de adicionar à Hoobuy Spreadsheet. Trabalhamos apenas com fornecedores confiáveis e mantemos atualizações frequentes para garantir a melhor experiência de compra.
            </p>

            <div className="space-y-4 mb-8">
              {[
                { icon: "ri-links-line", label: "Links verificados manualmente" },
                { icon: "ri-shield-star-line", label: "Controle de qualidade dos produtos" },
                { icon: "ri-user-heart-line", label: "Vendedores com bom feedback" },
                { icon: "ri-refresh-line", label: "Atualização semanal da planilha" },
              ].map((item) => (
                <div key={item.label} className="flex items-center gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                    <i className={`${item.icon} text-sm`}></i>
                  </div>
                  <span className="text-sm text-foreground-700">{item.label}</span>
                </div>
              ))}
            </div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Comprar com Segurança
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}